import React, { useState } from "react";
import DirectForm from "./directForm";
import ConsolForm from "./consolForm";
import ParcialForm from "./parcialForm";





function Form({ master, houses, merchandise_types, options, years, is_direct, is_consolidated, is_parcial, goBack }) {



  const masterInfo = [
    { label: "Master", value: master?.master },
    { label: "Origen inicial", value: master?.final_origin },
    { label: "Origen", value: master?.origin },
    { label: "Destino", value: master?.destiny },
    { label: "Destino final", value: master?.final_destination },
    { label: "Piezas Master", value: master?.pieces },
    { label: "Gross Weight Master", value: master?.weight },
    { label: "Chargeable Weight Master", value: master?.chargeable_weight },
    { label: "Volumen Master", value: master?.volume },
    { label: "Tipo de mercancía", value: merchandise_types?.[master?.merchandise_type], },
    { label: "Vuelo", value: master?.flight },
    { label: "Año", value: master?.year },
    { label: "Descripción master", value: master?.description },
  ];

  const [formType, setFormType] = useState("");

  const renderFormByType = () => {
    switch (formType) {
      case "1":
        return <DirectForm master={master} merchandise_types={merchandise_types} goBack={goBack} years={years} />;
      case "2":
        return <ConsolForm master={master} merchandise_types={merchandise_types} goBack={goBack} years={years} />;
      case "3":
        return <ParcialForm master={master} merchandise_types={merchandise_types} goBack={goBack} years={years} />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* is_consolidated || $is_parcial */}

      <div className="container-fluid">
        {/* HEADER ESTATICO */}
        <div className="row">
          <div className="col-12">
            <div className="row">
              {masterInfo.map((item, index) => (
                <div
                  key={index}
                  className={`mb-3 ${item.label === "Tipo de mercancía" ? "col-md-5" : "col-md-3"
                    }`}
                >
                  <label className="fw-bold">{item.label}</label>
                  <p className="mb-0">{item.value}</p>
                </div>
              ))}
            </div>

          </div>
        </div>
        {(is_consolidated || is_parcial) && (
          <div className="row mt-4 mb-4">
            <div className="col-12">
              <table className="table text-center mx-auto" style={{ maxWidth: "900px", width: "100%" }}>
                <thead className="table-light fondo-headUPD">
                  <tr style={{ fontSize: "13px" }}>
                    <th>HBS</th>
                    <th>Piezas</th>
                    <th>Gross Weight</th>
                    <th>Chargeable Weight</th>
                    <th>Volumen</th>
                    <th>Tipo de mercancia</th>
                    <th>Descripción</th>
                    <th>Vuelo</th>
                  </tr>
                </thead>
                <tbody>
                  {houses?.length > 0 ? (
                    houses.map((house, index) => (
                      <tr key={house.id || index} style={{ fontSize: "13px" }}>
                        <td>{house.hbs}</td>
                        <td>{house.pieces}</td>
                        <td>{house.gross_weight}</td>
                        <td>{house.chargeable_weight}</td>
                        <td>{house.volume}</td>
                        <td>
                          {merchandise_types?.[Number(house.merchandise_type_id)] || "-"}                        </td>
                        <td>{house.description}</td>
                        <td> {[house?.flight, house?.year_flight, house?.time_flight]
                          .filter(Boolean)
                          .join(" ")}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center text-muted">
                        No hay houses registradas
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

          </div>
        )}


        <div className="row mt-4 mb-4 d-flex justify-content-center">
          <div class="col-md-4 col-md-offset-4">
            <p class="text-center">Seleccione el tipo de cambio para su factura</p>
            <select
              name="operation_type"
              className="form-select w-100"
              value={formType}
              onChange={(e) => setFormType(e.target.value)}
            >
              <option value="">Selecciona una opción:</option>
              {Object.entries(options || {}).map(([id, label]) => (
                <option key={id} value={id}>
                  {label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* SELECT TIPO */}


        {/* FORMULARIO DINÁMICO */}
        {renderFormByType()}

      </div>

    </>
  );
}


export default Form;